import { render, staticRenderFns } from "./SocialFeedList.vue?vue&type=template&id=5a9d852c"
import script from "./SocialFeedList.vue?vue&type=script&lang=js"
export * from "./SocialFeedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports